import './FormDisplay.css';
import React from 'react';

interface Props {
  label?: string;
  value?: string;
}

export function FormDisplay({ label, value }: Props): JSX.Element {
  return (
    <div className="form-display">
      <div className="form-display__label">{label}</div>
      <div className="form-display__value">{value}</div>
    </div>
  );
}
